import { ethers } from "ethers";
import timeLockAbi from "src/hooks/abis/timelock.json";
import { timeLock } from "./address";

export function checkMetaMask() {
  let isMetaMask = false;
  if (window.ethereum) {
    isMetaMask = true;
  }
  return isMetaMask;
}

export function sortAddress(add) {
  const sortAdd = `${add.slice(0, 6)}...${add.slice(add.length - 4)}`;
  return sortAdd;
}

export async function getProvider() {
  const provider = await new ethers.providers.Web3Provider(window.ethereum);
  return provider;
}

// const getMyAccount = () => {
//   const myAdd = window.sessionStorage.getItem("account");
//   return myAdd;
// };

export async function connectToWallet() {
  await window.ethereum.request({ method: "eth_requestAccounts" });
  const provider = await getProvider();
  const signer = await provider.getSigner();
  let myAddress = await signer.getAddress();
  window.sessionStorage.setItem("account", myAddress);
  return "connected";
}

export async function getOwner() {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const owner = await contract.owner();
  return owner;
}

export async function getData(account) {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const MAX_NUM_TESTTOKENS = await contract.MAX_NUM_TESTTOKENS();
  // console.log({ contract, account });
  const icedBalancesPvtSale1 = await contract.mapicedBalancesPvtSale1(account);
  const icedBalancesPvtSale2 = await contract.mapicedBalancesPvtSale2(account);
  const unlockedBalanceOf = await contract.unlockedBalanceOf(account);
  const mapicedBalancesStrategicSale = await contract.mapicedBalancesStrategicSale(
    account
  );
  const totalicedBalancesPvtSale1 = await contract.totalicedBalancesPvtSale1(
    account
  );
  const totalicedBalancesPvtSale2 = await contract.totalicedBalancesPvtSale2(
    account
  );
  const totalicedBalancesStrategicSale = await contract.totalicedBalancesStrategicSale(
    account
  );
  const totalPublicSaleSupply = await contract.totalPublicSaleSupply();
  const totalSupply = await contract.totalSupply();
  const totalPvt1Supply = await contract.totalPvt1Supply();
  const totalPvt2Supply = await contract.totalPvt2Supply();
  const totalStrategicSupply = await contract.totalStrategicSupply();
  const totalAirdropSupply = await contract.totalAirdropSupply();
  const totalBalance = await contract.totalBalanceOf(account);
  const totalStake = await contract.balanceOf(account);
  const stakeInfo = await contract.StakeInfo(account);
  let tierData = {
    name: "Main Sale",
    value: "0.00",
    stake: "",
  };
  if (ethers.utils.formatEther(icedBalancesPvtSale1) !== "0.0") {
    tierData = {
      name: "Private Sale 1",
      stake: ethers.utils.formatEther(totalicedBalancesPvtSale1),
      value: ethers.utils.formatEther(icedBalancesPvtSale1),
    };
  } else if (ethers.utils.formatEther(icedBalancesPvtSale2) !== "0.0") {
    tierData = {
      name: "Private Sale 2",
      stake: ethers.utils.formatEther(totalicedBalancesPvtSale2),
      value: ethers.utils.formatEther(icedBalancesPvtSale2),
    };
  } else if (ethers.utils.formatEther(mapicedBalancesStrategicSale) !== "0.0") {
    tierData = {
      name: "Strategic Sale",
      stake: ethers.utils.formatEther(totalicedBalancesStrategicSale),
      value: ethers.utils.formatEther(mapicedBalancesStrategicSale),
    };
  } else {
    tierData = {
      name: "Public Sale",
      stake: "0.0",
      value: ethers.utils.formatEther(totalPublicSaleSupply),
    };
  }
  const canUnlock = await contract.getReaminingTime(account);
  const data = {
    MAX_NUM_TESTTOKENS: ethers.utils.formatEther(MAX_NUM_TESTTOKENS),
    totalBalance: ethers.utils.formatEther(totalBalance),
    unlockedBalanceOf: ethers.utils.formatEther(unlockedBalanceOf),
    totalPvt1Supply: ethers.utils.formatEther(totalPvt1Supply),
    totalPvt2Supply: ethers.utils.formatEther(totalPvt2Supply),
    totalStrategicSupply: ethers.utils.formatEther(totalStrategicSupply),
    totalAirdropSupply: ethers.utils.formatEther(totalAirdropSupply),
    tierName: tierData.name,
    totalStake: ethers.utils.formatEther(totalStake),
    tierBalance: tierData.value,
    totalSupply: ethers.utils.formatEther(totalSupply),
    canUnlock,
    stakeAmount: ethers.utils.formatEther(stakeInfo.stakeamount),
  };
  // console.log(data);

  return data;
}

export async function batchAssignTokens(data) {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const signer = await provider.getSigner();
  const contractWithSigner = contract.connect(signer);
  try {
    const res = await contractWithSigner.batchAssignTokens(
      data.address,
      data.amount,
      data.tier
    );
    await res.wait();
    return "Done";
  } catch (error) {
    return "Something went wrong!";
  }
}

export async function transfer(address, amount) {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const signer = await provider.getSigner();
  const contractWithSigner = contract.connect(signer);
  try {
    const res = await contractWithSigner.transfer(
      address,
      ethers.utils.parseEther(amount)
    );
    await res.wait();
    return "Done";
  } catch (error) {
    console.log(error);
    return "Something went wrong!";
  }
}
export async function canDefrostStaking() {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const res = await contract.InitTknUnlockStatus();
  return res;
}

export async function defrostToken() {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const signer = await provider.getSigner();
  const contractWithSigner = contract.connect(signer);
  const res = await contract.InitTknUnlockStatus();
  const res1 = await contract.CycleTknUnlockStatus();
  let tokens;
  if (res || res1) {
    tokens = await contractWithSigner.defrostTokens();
  }
  return tokens;
}

export async function monthlyTranche() {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const res = await contract.CycleTknUnlockStatus();
  return res;
}
export async function monthCount() {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const res = await contract.monthIndex();
  return ethers.utils.formatEther(res);
}

export async function stake(address, value) {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const signer = await provider.getSigner();
  const contractWithSigner = contract.connect(signer);
  // const balance = await contractWithSigner.unlockedBalanceOf(address);
  const stakeValue = ethers.utils.parseEther(value)
  const res = await contractWithSigner.staking(stakeValue);
  await res.wait();
  return res;
}
export async function canUnlock(address) {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const res = await contract.getReaminingTime(address);
  return res;
}
export async function unlock(address) {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);

  const stakeInfo = await contract.StakeInfo(address);
  // console.log(stakeInfo.stakeamount);
  const signer = await provider.getSigner();
  const contractWithSigner = contract.connect(signer);
  const res = await contractWithSigner.Unstaking(
    address,
    stakeInfo.stakeamount
  );
  await res.wait();
  return res;
}

export async function getStakeDetails(address) {
  const provider = await getProvider();
  const contract = new ethers.Contract(timeLock, timeLockAbi, provider);
  const res = await contract.StakeInfo(address);
  // console.log(res);
  const data = {
    stakeAmount: ethers.utils.formatEther(res.stakeamount),
    startTime: res.startTime.toString(),
  };
  console.log(data);
  return data;
}
